//    _____ __
//   / ___// /_____  _________ _____ ____
//   \__ \/ __/ __ \/ ___/ __ `/ __ `/ _ \
//  ___/ / /_/ /_/ / /  / /_/ / /_/ /  __/
// /____/\__/\____/_/   \__,_/\__, /\___/
//                           /____/

const AddToStorage = (elem, value) => {
    sessionStorage.setItem(elem, value);
}

const RemoveFromStorage = (elem) => {
    sessionStorage.removeItem(elem);
}

const FetchFromStorage = (elem) => {
    return sessionStorage.getItem(elem);
}

//    _____ __        __          __  ___                                                  __
//   / ___// /_____ _/ /____     /  |/  /___ _____  ____ _____ ____  ____ ___  ___  ____  / /_
//   \__ \/ __/ __ `/ __/ _ \   / /|_/ / __ `/ __ \/ __ `/ __ `/ _ \/ __ `__ \/ _ \/ __ \/ __/
//  ___/ / /_/ /_/ / /_/  __/  / /  / / /_/ / / / / /_/ / /_/ /  __/ / / / / /  __/ / / / /_
// /____/\__/\__,_/\__/\___/  /_/  /_/\__,_/_/ /_/\__,_/\__, /\___/_/ /_/ /_/\___/_/ /_/\__/
//                                                     /____/

const LoadState = () => {
    try {
        const serializedData = sessionStorage.getItem('state');
        if (serializedData == null) {
            return undefined;
        }
        return JSON.parse(serializedData);
    } catch (err) {
        return undefined;
    }
}

const SaveState = (state) => {
    try {
        const serializedState = JSON.stringify(state);
        sessionStorage.setItem('state', serializedState);
    } catch (err) {
        // Ignore write errors
    }
}

//     ______                      __     __  __     __
//    / ____/  ______  ____  _____/ /_   / / / /__  / /___  ___  __________
//   / __/ | |/_/ __ \/ __ \/ ___/ __/  / /_/ / _ \/ / __ \/ _ \/ ___/ ___/
//  / /____>  </ / _ / / /_ / / / / /_   / __ / __ / / /_ / /  __/ / (__)
// /_____/_/|_/ .___/\____/_/   \__/  /_/ /_/\___/_/ .___/\___/_/  /____/
//           /_/                                  /_/

export const Storage = {
    "Add": AddToStorage,
    "Remove": RemoveFromStorage,
    "Fetch": FetchFromStorage
}

export const State = {
    "Save": SaveState,
    "Load": LoadState
}